import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getAnalyticPermissions = async (token) => {
  const url = `analytic_permissions`
  const data = await apiGet({ url, token })
  return data
}

export default function useAnalyticPermissions({ options = {} }) {
  const token = useContext(AuthContext)

  const queryFn = () => getAnalyticPermissions(token)
  const queryKey = 'analyticPermissions'

  return useQuery(queryKey, queryFn, { ...options })
}
